@if(model$ | async; as model){
  <div class="udex-grid udex-mx-auto" data-cy="search-results-grid">
    <div class="row flex-wrap justify-content-start align-items-stretch tile-row">
    @if(!model.products.length){
      <div class="udex-mx-auto text-center">
        <h3 class="heading__regular--xl udex-mb-12 udex-pt-40">{{'search.noSearchResults.header' | cxTranslate}}</h3>
        <p class="body--m text-gray udex-pb-40 udex-mb-40 border-bottom">
          {{'search.noSearchResults.description' | cxTranslate}}
        </p>

        <div class="d-md-flex gap-6 text-start col-lg-10 udex-mx-auto">
          @for(item of emptyResultData; track $index){
            <div class="udex-mb-48 udex-mb-md-0">
              <h4 class="heading__medium--xxs">{{item.title}}</h4>
              <p class="body--s text-gray">{{item.paragraph}}</p>
            </div>
          }
        </div>
      </div>
    } @else {
      @for(product of model?.products; track $index){
        <div class="col-12 col-sm-6 col-lg-3 udex-mt-48">
          <div class="position-relative h-100">
            <dcp-product-tile [product]="product" [clickRank]="$index"></dcp-product-tile>
          </div>
        </div>
      }
    }
    </div>
  </div>
}
